import { CLASS_ACCESS_TYPE } from '../models';
import { useClassAccessType } from './useClassAccessType';

export const useDoesClassImpactQuota = (classId: string) => {
  const classAccessType = useClassAccessType(classId);
  return classAccessType === CLASS_ACCESS_TYPE.PREMIUM;
};
